import type { FetchLiveAuctionsConfigResponse } from '@/redux/api/config';
import type { TypedActionWithPayload } from '@/types/redux';

export const LOAD_LIVE_CATALOGS_CONFIG_SUCCESS = 'LOAD_LIVE_CATALOGS_CONFIG_SUCCESS';
export type LOAD_LIVE_CATALOGS_CONFIG_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_LIVE_CATALOGS_CONFIG_SUCCESS,
    FetchLiveAuctionsConfigResponse
>;
